module.exports = __webpack_public_path__ + "static/media/arrow_left.86e45c44.svg";